import React from 'react';
import * as DateFns from 'date-fns';

import { NUMBER_OF_WEEK_DAYS } from '../../../../../config/constants';

const HeadCalendar = ({ date }: { date: Date }) => {
  const daysWeek = [];
  const startDate = DateFns.startOfWeek(new Date());
  for (let i = 0; i < NUMBER_OF_WEEK_DAYS; i++) {
    daysWeek.push(
      <div className="small-month-days-col" key={i}>
        {DateFns.format(DateFns.addDays(startDate, i), 'EEEEE')}
      </div>
    );
  }
  const now = new Date();
  return (
    <>
      <div
        className={`month-h ${DateFns.isSameMonth(now, date) && DateFns.isSameYear(now, date) ? 'month-h-today' : ''}`}>
        {DateFns.format(date, 'MMMM yyyy')}
      </div>
      <div className="small-month-days">{daysWeek}</div>
    </>
  );
};

export default HeadCalendar;
